import { Mac, SecurityEvent } from 'Consts/types';
import * as api from 'Api/endpoints';
import type { RootState, Action } from 'State/store';
import { createStandardSlice } from '../utils';

const slice = createStandardSlice<SecurityEvent[]>('deviceSecurityEvents');

const fetchData = (mac: Mac): Action => {
  return async (dispatch, getState) => {
    const { activeLocation } = getState().locations;
    const customerId = activeLocation?.customerId;
    const { data: token } = getState().locations.activeLocation
      ?.accessedAsCoAdminLocation
      ? getState().auth.coAdminData
      : getState().auth.data;
    const cloud = getState().auth.cloud;
    const deviceSecurityEventsData = getState().deviceSecurityEvents;

    if (
      deviceSecurityEventsData.isLoading ||
      !customerId ||
      !token ||
      !activeLocation?.id
    ) {
      return;
    }

    dispatch(actions.isLoading(true));

    const { data, error } = await api.getDeviceSecurityEvents({
      customerId,
      locationId: activeLocation.id,
      mac,
      token,
      cloud,
    });

    if (error || !data) {
      dispatch(
        actions.error(
          error?.message || 'Error fetching device security events data'
        )
      );

      return;
    }

    dispatch(actions.set(data));
  };
};

export const selectors = (state: RootState) => state.deviceSecurityEvents;

export const actions = {
  ...slice.actions,
  fetchData,
};

export default slice.reducer;
